import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/community/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/community/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/community/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/community/submit', params, options);

export const update = (params, options) => request.post('/api/community/submit', params, options);
